import React from 'react'
import {
  ChevronRight,
  CreditCard,
} from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
export default function DepositContent() {
  return (
    <div className="px-3 pt-3">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
      >
        <div className="flex items-center mb-4">
          <CreditCard className="w-6 h-6 text-orange-500 mr-2" />
          <h1 className="text-white text-xl font-bold">Depósito/Retiro</h1>
        </div>

        <div className="flex space-x-2 mb-4">
          <motion.button
            className="bg-orange-500 text-white rounded-full px-4 py-2 text-sm font-medium flex-1"
            whileTap={{ scale: 0.95 }}
          >
            Depósito
          </motion.button>
          <motion.button
            className="bg-gray-700 text-gray-300 rounded-full px-4 py-2 text-sm flex-1"
            whileTap={{ scale: 0.95 }}
          >
            Retiro
          </motion.button>
        </div>

        <div className="bg-gray-800 rounded-lg p-4 mb-4">
          <div className="text-gray-400 text-sm mb-2">Cantidad a depositar</div>
          <div className="relative mb-4">
            <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-white">
              $
            </span>
            <input
              type="text"
              placeholder="0.00"
              className="w-full bg-gray-700 text-white rounded-lg py-3 pl-8 pr-4 text-lg font-medium focus:outline-none focus:ring-2 focus:ring-orange-500"
            />
          </div>

          <div className="flex justify-between gap-2 mb-4">
            {[100, 200, 500, 1000].map((amount) => (
              <motion.button
                key={amount}
                className="bg-gray-700 text-white rounded px-2 py-1 text-sm flex-1"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                ${amount}
              </motion.button>
            ))}
          </div>
        </div>

        <div className="bg-gray-800 rounded-lg p-4 mb-4">
          <div className="text-white text-sm font-medium mb-3">
            Método de pago
          </div>
          <div className="space-y-2">
            {[
              { name: "Tarjeta de crédito", icon: "💳" },
              { name: "Transferencia bancaria", icon: "🏦" },
              { name: "Billetera electrónica", icon: "📱" },
              { name: "Criptomonedas", icon: "₿" },
            ].map((method, index) => (
              <motion.div
                key={index}
                className="bg-gray-700 rounded-lg p-3 flex justify-between items-center"
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
              >
                <div className="flex items-center">
                  <div className="mr-3 text-xl">{method.icon}</div>
                  <span className="text-white">{method.name}</span>
                </div>
                <ChevronRight className="w-4 h-4 text-gray-400" />
              </motion.div>
            ))}
          </div>
        </div>

        <motion.button
          className="bg-orange-500 text-white rounded-lg py-3 font-medium w-full mb-4"
          whileHover={{ scale: 1.03 }}
          whileTap={{ scale: 0.97 }}
        >
          Realizar depósito
        </motion.button>
      </motion.div>
    </div>
  );
}
